import { makeStyles } from '@material-ui/core';
import React from 'react';
import Page from 'src/components/Page';

const useStyles = makeStyles(() => ({
  root: {}
}));

function HomeView() {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Home"
    >
   {/*}   <Hero />
      <Features />
      <Testimonials />
      <CTA />
      <FAQS />*/}
  </Page>
  );
}

export default HomeView;
